import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './app'
import { setDynamicSettings } from './config/settings'

initDynamicSettings()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

function initDynamicSettings() {
  const searchParams = new URLSearchParams(window.location.search)
  const accessToken = searchParams.get('accessToken')

  setDynamicSettings({
    accessToken: accessToken,
  })
}
